import p from './zoomOut';

export * from './zoomOut';
export default p;
